import './style.css';
import React, { Fragment, useEffect, useState } from 'react'
import { http_request } from '../../../../libs/connection';
import { BASE_ROUTE, SESSION_EXPIRED_CODE } from '../../../../config';
import { createTimeString } from '../../../../libs/lib';
import { BsArrowReturnLeft } from 'react-icons/bs';
import Progress from '../../../../components/progress';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function OutsourcingRefundDetail() {
    const MAX_COLUMNS = 6;
    const LINES_PER_ROW = 2;//每一个 row 有2行组成所以空白行也 * 2
    const url_params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const { mt_list } = url_params;
    const [is_loading, setLoadingStatus] = useState(false);
    const [order, setOrder] = useState({});
    const [empty_rows, setEmptyRows] = useState([LINES_PER_ROW]);


    useEffect(()=>{
        loadOrder();
    }, [pathname, mt_list]);

    function loadOrder(){
        if(!mt_list) return;
        let params = {
            mt_list
        };
        setLoadingStatus(true);
        http_request('/outsourcingReturnOrder/get', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let raw_data = res.data.outsourcing_return_orders;
                if(raw_data.length === 0) return;
                let order = raw_data[0];
                order.detail = raw_data.filter(od=>od.flag !== 'D').map(row=>Object.assign({}, row));
                for(let i = 0 ; i < order.detail.length ; i++){
                    delete order.detail[i].detail;
                }
                let epr = 4 - order.detail.length;
                if(epr <= 0 ) epr = 1;
                epr *= LINES_PER_ROW;
                setEmptyRows((new Array(epr)).fill(1));
                setOrder(order);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    return (
        <div id="page-outsourcing-refund-detail" className='page'>
            <Progress show={is_loading} variant="primary" />
            <div className={`bg-white d-block content `}>
                <div className={`d-flex align-items-center justify-content-between py-3 px-2 container head-container`}>
                    <span className='text-secondary pe-5 d-flex align-items-center' onClick={()=>{ navigate(-1) }}>
                        <BsArrowReturnLeft size={20} className='pe-2' />
                        <span>返回</span>
                    </span>
                </div>
                <div className={`overflow-auto table-container`}>
                    <table className={`border border-dark m-auto  dtable`}>
                        <thead>
                            <tr>
                                <th className='text-center' colSpan={4}>
                                    <h1>凹凸精密机械有限公司</h1>
                                    <h3>外包退回出库单(2.5.5)</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="underline">
                            <tr>
                                <td colSpan={3}>列印日期：{createTimeString('y/m/d')}</td>
                                <td className='text-end'>页：{1}/{1}</td>
                            </tr>
                            <tr>
                                <td>异动单号：{mt_list}</td>
                                <td colSpan={2}>单据日期：{createTimeString('y/m/d', order.mt_date)}</td>
                                <td>经办人员：{order.cu_snam}</td>
                            </tr>
                            <tr>
                                <td colSpan={4}>厂　　商：{order.cu_name}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody className='underline text-center'>
                            <tr className='fw-bold'>
                                <td className='border-dark border-top-0 text-start'>来源单号</td>
                                <td className='border-dark border-top-0 text-start' colSpan={2}>来源项</td>
                                <td className='border-dark border-top-0 text-start'>外包单号</td>
                                <td className='border-dark border-top-0 text-start'>库位</td>
                                <td className='border-dark border-top-0 text-start'>出库量</td>
                            </tr>
                            <tr className='underline fw-bold'>
                                <td className='border-dark border-top-0 text-start'>料品编号</td>
                                <td className='border-dark border-top-0 text-start'>版别</td>
                                <td className='border-dark border-top-0 text-start' colSpan={2}>品名</td>
                                <td className='border-dark border-top-0 text-start' colSpan={2}>规格</td>
                            </tr>
                            {
                                (order.detail || []).map((row, r)=><Fragment key={r}>
                                    <tr>
                                        <td className="text-start">{row.ref_no}</td>
                                        <td className="text-start">{row.ref_seq}</td>
                                        <td className="text-start">{row.mt_refr}</td>
                                        <td className="text-start">{row.mt_areana}</td>
                                        <td className="text-start">{row.mt_qty2}{row.unit2}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start" colSpan={2}>{row.el_no}</td>
                                        <td className="text-start" colSpan={2}>{row.el_name1}</td>
                                        <td className="text-start" colSpan={2}>{row.el_size}</td>
                                    </tr>
                                    <tr className='underline-dashed'>
                                        <td className="text-start" colSpan={6}>备註：{row.mt_remkd}</td>
                                    </tr>
                                </Fragment>)
                            }
                            {
                                empty_rows.map((row, r)=><tr key={r}><td colSpan={MAX_COLUMNS}>　</td></tr>)
                            }
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody>
                            <tr>
                                <td>{order.ar_relna}</td>
                            </tr>
                            <tr>
                                <td>{order.ar_asgna}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default OutsourcingRefundDetail;
